export const LANGUAGE_TYPE_OPTIONS = [
  { value: 'audio', label: 'audio' },
  { value: 'subtitle', label: 'subtitle' },
  { value: 'write', label: 'write' },
];
